import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { IStatusMobileUsersModel } from './types';

const statusMobileUsers: IStatusMobileUsersModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default statusMobileUsers;
